<template>
  <footer class="site-footer" id="footer">
    <div class="footer-inner">
      <div class="footer-main">
        <div class="footer-links">
          <router-link
            v-for="link in legalLinks"
            :key="link.to"
            :to="link.to"
          >
            {{ link.label }}
          </router-link>
          <span>版权声明</span>
        </div>
        <p>{{ companyInfo.copyright }}</p>
      </div>
      <div class="footer-meta">
        ICP备案号：
        <a :href="companyInfo.icpUrl" target="_blank" rel="noopener">
          {{ companyInfo.icp }}
        </a>
      </div>
    </div>
  </footer>
</template>

<script>
import { companyInfo } from '@/data/company'
import { getLegalNavLinks } from '@/data/legal'

export default {
  name: 'SiteFooter',
  data() {
    return {
      companyInfo,
      legalLinks: getLegalNavLinks()
    }
  }
}
</script>

<style scoped lang="scss">
.site-footer {
  border-top: 1px solid var(--line);
  background: #111827;
  color: rgba(255, 255, 255, 0.78);
}

.footer-inner {
  width: min(1120px, calc(100% - 40px));
  margin: 0 auto;
  padding: 30px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
}

.footer-links {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 16px;
  font-size: 14px;
  max-width: 720px;

  a {
    color: inherit;
    text-decoration: none;

    &:hover {
      color: #fff;
    }
  }
}

.footer-main p {
  margin: 12px 0 0;
  color: rgba(255, 255, 255, 0.62);
  font-size: 13px;
}

.footer-meta {
  text-align: right;
  color: rgba(255, 255, 255, 0.62);
  font-size: 13px;
  word-break: break-word;

  a {
    color: inherit;
    text-decoration: none;
  }
}

@media (max-width: 640px) {
  .footer-inner {
    width: min(100% - 32px, 1120px);
    align-items: flex-start;
    flex-direction: column;
  }

  .footer-meta {
    text-align: left;
  }
}
</style>
